<template>
	<div class="privacy-info">
		<span class="privacy-title">隐私设置</span>
		<privacy-company></privacy-company>
		<privacy-industry v-if="showIndustry"></privacy-industry>
	</div>
</template>
<script>
	import privacyCompany from './privacyCompany';
	import privacyIndustry from './privacyIndustry';
	import {
		mapGetters
	} from 'vuex';
	export default {
		components: {
			privacyCompany,
			privacyIndustry
		},
		computed: {
			...mapGetters(['showIndustry'])
		}
	};

</script>
<style lang="scss" scoped>
	@import '../../../assets/style/public.scss';
	.privacy-info {
		background: #ffffff;
		font-size: px2rem(38px);
		padding-top: px2rem(30px);
	}

	.privacy-title {
		font-size: px2rem(28px);
		line-height: px2rem(28px);
		color: #999999;
		margin: 0 px2rem(30px) px2rem(13px);
	}

	// .privacy-company-box,
	// .privacy-industry-box {
	// 	height: px2rem(138px);
	// }
	// .privacy-show {
	// 	background: #fff;
	// }
	// .privacy-title {
	// 	display: block;
	// 	color: #999;
	// 	font-size: px2rem(28px);
	// 	padding: px2rem(30px) 0 0 px2rem(30px);
	// }
	// .privacy-company,
	// .privacy-industry {
	// 	color: #ccc;
	// 	padding: px2rem(30px) 0 px2rem(25px);
	// 	margin: 0 px2rem(30px);
	// 	text-align: center;
	// 	font-size: px2rem(24px);
	// 	position: relative;
	// }
	// .privacy-company {
	// 	border-bottom: 1px solid #f3f3f3;
	// }
	// .choose-company,
	// .choose-industry {
	// 	font-size: px2rem(38px);
	// 	color: #000;
	// 	display: block;
	// 	overflow: hidden;
	// 	white-space: nowrap;
	// 	text-overflow: ellipsis;
	// 	position: relative;
	// }

</style>



// WEBPACK FOOTER //
// index.vue?6f473ac2